<template>
  <div class="form-question">
    <gkForm ref="form" name="form" v-model="formData">
      <template v-for="(questionItem, i) in data" >
        <QuestionModule
          v-show="questionItem.showQuestion"
          :itemInfo="questionItem"
          :key="`${questionItem.type}-${i}`"
          :answersWriting="answersWriting"
          :userFieldInfo="userFieldInfo"
          @judgeRule="judgeRule"
        />
      </template>
    </gkForm>
    <div class="btns">
      <div class="btn-prev" v-if="currentPage !== 0">
        <gkButton color="blue" size="height34" useLock @click="changePage($event, 'prev')">上一页</gkButton>
      </div>
      <div class="btn-next" v-if="currentPage < maxPage">
        <gkButton color="blue" size="height34" useLock @click="changePage($event, 'next')">下一页</gkButton>
      </div>
      <div class="submit" v-if="currentPage === maxPage">
        <gkButton color="blue" size="height34" data-sensors-click useLock @click="handleSubmit($event)">提交</gkButton>
      </div>
    </div>

    <template
      v-if="
        currentPage === maxPage &&
        protocols.length
      ">
      <div
        class="agreement-wrap"
        v-for="(protocol, index) in protocols"
        :key="`protocol-${index}`"
      >
        <gkCheck
          class="agree-check"
          color="agree"
          bool
          type="checkbox"
          :value="true"
          :selected="protocol.isAgree"
          @change="protoCheckHandler($event, index)"
        ></gkCheck>
        <span class="agree-label">
          {{ protocol.prefix || '我已阅读并同意' }} <span class="agree-label-word" @click="jumpUrl(protocol.url)">{{ protocol.name || '《隐私条款》'}}</span>
        </span>
      </div>
    </template>
  </div>
</template>
<script>
import { mapState } from 'vuex'
// import utils from '../../utils'

import VueTypes from 'vue-types'
import QuestionModule from './QuestionModule'

import gkForm from 'gkui/form/Form'
import gkButton from 'gkui/button'
import gkCheck from 'gkui/form/FormCheck'

import {
  urlToScheme,
  universalJump
} from '@geekbang/time.sdk'

// const specialFormArr = [
//   // {
//   //   id: 258, agreLink: 'https://www.cloudera.com/legal/terms-and-conditions.html'
//   // },
//   {
//     id: 597, agreLink: 'https://www.cloudera.com/legal/terms-and-conditions.html'
//   },
//   {
//     id: 887, agreLink: `https://static001.geekbang.org/static/biz/file/form/privacy2.pdf?id=${Date.now()}`
//   },
//   {
//     id: 893, agreLink: `https://static001.geekbang.org/static/biz/file/form/privacy2.pdf?id=${Date.now()}`
//   },
//   {
//     id: 855, agreLink: `https://static001.geekbang.org/static/biz/file/form/privacy2.pdf?id=${Date.now()}`
//   },
//   {
//     id: 857, agreLink: `https://static001.geekbang.org/static/biz/file/form/privacy.pdf?id=${Date.now()}`, agreWord: '《隐私政策》'
//   },
//   {
//     id: 858, agreLink: `https://static001.geekbang.org/static/biz/file/form/privacy.pdf?id=${Date.now()}`, agreWord: '《隐私政策》'
//   }
// ]

export default {
  name: 'form-question',
  components: {
    QuestionModule,
    gkButton,
    gkForm,
    gkCheck
  },
  props: {
    data: VueTypes.array,
    userFieldInfo: VueTypes.object.def({}),
    currentPage: VueTypes.number,
    maxPage: VueTypes.number,
    answersWriting: VueTypes.array,
    formId: VueTypes.string,
    protocols: VueTypes.array.def([])
  },
  provide () {
    return {
      getFormRef: () => this.$refs.form
    }
  },
  data () {
    return {
      formData: {},
      // 一些没用的信息需要过滤删除
      filterObj: ['addressUseless', 'radioUseless', 'checkUseless', 'phoneUseless']
    }
  },
  computed: {
    ...mapState([
      'isMobile'
    ])
    // specialForm () {
    //   return specialFormArr.find(item => String(item.id) === this.formId)
    // },
    /**
     * 测试 258     线上 597
     */
    // isSpecial () {
    //   return !!this.specialForm
    // }
  },
  methods: {
    handleSubmit ({clear}) {
      if (this.protocols.length && this.protocols.findIndex(item => !item.isAgree) > -1) {
        this.$Message.toast({
          message: '请同意隐私条款'
        })
        clear && clear()
        return
      }
      this.changePage({clear}, 'submit')
    },
    protoCheckHandler (val, index) {
      this.$emit('updateProtocols', {
        index,
        val
      })
    },
    changePage ({ clear }, type) {
      // 上一页
      if (type === 'prev') {
        clear && clear()
        this.$emit('changePage', {
          type,
          clear: () => {
            clear && clear()
          }
        })
      } else {
        // 提交 || 下一页
        let answers = null
        this.$refs.form.validate().then(res => {
          answers = res.formData

          this.filterObj.forEach(item => {
            if (answers[item]) {
              this.$delete(answers, item)
            }
          })

          this.$emit('changePage', {
            type,
            answers,
            clear: () => {
              clear && clear()
            }
          })
        }).catch(err => {
          clear && clear()
          console.log(err)
        })
      }
    },
    judgeRule (qInfo) {
      this.$emit('judgeRule', qInfo)
    },
    jumpUrl (url) {
      const scheme = urlToScheme(url)
      console.log(scheme, url)
      universalJump(scheme, url, true)
    }
  }
}
</script>
<style lang="scss" scoped>
@import "../../assets/css/_common";

.form-question {

  & .btns {
    display: flex;
    justify-content: center;

    & .btn-prev,
    & .btn-next,
    & .submit {
      width: 123px;
    }

    & .btn-prev {
      margin-right: 16px;
    }
  }
}

.agreement-wrap {
  display: flex;
  justify-content: center;
  align-items: center;
  margin-top: 16px;

  @include font(14);
  color: $gray;

  & .agree-check::v-deep {
    & [gkcheck-color="agree"] {
      width: 14px; height: 14px;
      margin-right: 5px;
    }

    & [gk-checked] {
      width: 14px; height: 14px;

      &:after {
        left: 2px; top: 3px;
        width: 9px; height: 5px;
        // transform: scale(0.6) rotate(-45deg);
      }
    }
  }

  & .agree-label {
    padding-top: 1px;
    line-height: 1;
  }

  & .agree-label-word {
    color: $blue;
    text-decoration: underline;
    cursor: pointer;
  }
}
</style>
